import { useFlags } from 'launchdarkly-react-client-sdk';

export const useFeatureCommunityEnabled = (): boolean => {
  const flags = useFlags();
  return flags.featureCommunityEnabled ?? true;
};

export const useFeatureAccountingEnabled = (): boolean => {
  const flags = useFlags();
  return flags.featureAccountingEnabled ?? false;
};

export const useFeatureFinancialInsightEnabled = (): boolean => {
  const flags = useFlags();
  return flags.featureFinancialInsightEnabled ?? false;
};

export const useFeatureCustomerStatementEnabled = (): boolean => {
  const flags = useFlags();
  return flags.featureCustomerStatementEnabled ?? false;
};

export const useHiddenBillIds = (): number[] => {
  const flags = useFlags();
  return flags.featureVendorlinkHiddenBills?.hiddenBillIds ?? [];
};

export const useEnableBillCountBadge = (): boolean => {
  const flags = useFlags();
  return flags.featureVendorlinkEnableBillCountBadge ?? false;
};

export const useCheckDepositLimit = (): number => {
  const flags = useFlags();
  return flags.featureVendorlinkCheckDepositLimit ?? 10_000_00;
};
